import I18n from "i18n-js";
import { runInAction } from "mobx";
import { toPairs } from "../../core";
import { ErrorBox, TextFieldControler } from "../../form";
export class StreetAddressFormController {
    constructor(params) {
        var _a;
        this.streetAddress = params.streetAddress;
        this.geocodingService = params.geocodingService;
        this.geolocationService = params.geolocationService;
        this.fields = {
            street: new TextFieldControler({
                initialValue: this.streetAddress.street,
                update: (str) => (this.streetAddress.street = str),
                errorBox: new ErrorBox({
                    domainObjects: [this.streetAddress],
                    errorMessages: {
                        StreetMissing: I18n.t("_common.form.errors.required"),
                    },
                }),
            }),
            streetNumber: new TextFieldControler({
                initialValue: this.streetAddress.streetNumber,
                update: (str) => (this.streetAddress.streetNumber = str),
                errorBox: new ErrorBox({
                    domainObjects: [this.streetAddress],
                    errorMessages: {
                        StreetNumberMissing: I18n.t("_common.form.errors.required"),
                    },
                }),
            }),
            city: new TextFieldControler({
                initialValue: this.streetAddress.city,
                update: (str) => (this.streetAddress.city = str),
                errorBox: new ErrorBox({
                    domainObjects: [this.streetAddress],
                    // TODO: how to translate messages properly?
                    errorMessages: {
                        CityMissing: I18n.t("_common.form.errors.required"),
                    },
                }),
            }),
            postCode: new TextFieldControler({
                initialValue: (_a = this.streetAddress.postCode) !== null && _a !== void 0 ? _a : "",
                update: (str) => (this.streetAddress.postCode = str),
            }),
        };
    }
    get isPostCodeRequired() {
        return this.streetAddress.isPostCodeRequired;
    }
    touch() {
        toPairs(this.fields).forEach(([_, field]) => field.touch());
    }
    async locateMe() {
        const { latitude: lat, longitude: lon } = await this.geolocationService.getCurrentPosition();
        const streetAddress = await this.geocodingService.reverseGeocode(null, {
            lat,
            lon,
        });
        runInAction(() => {
            if (streetAddress) {
                this.fields.city.onChange(streetAddress.city);
                this.fields.street.onChange(streetAddress.street);
                this.fields.streetNumber.onChange(streetAddress.streetNumber);
                // TODO: postCode?
                this.touch();
            }
        });
        return streetAddress !== null;
    }
}
